<template>
  <base-page-layout title="Gerenciador de análises">
    <template v-slot:header>
      <mf-tooltip top :disabled="!allLimitsReached">
        <template #activator="{ on }">
          <mf-button :disabled="allLimitsReached" icon="add" label="Nova análise" @click="newReportDialogOpen = true" />
        </template>
        <span>Limite de relatórios atingido.</span>
      </mf-tooltip>
    </template>
    <generated-report-analytics-card ref="generatedReportAnalytics" />
    <new-report-dialog v-if="newReportDialogOpen" v-model="newReportDialogOpen" @analysis-generated="refetchData" />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import GeneratedReportAnalyticsCard from '../components/ReportAnalytics/GeneratedReportAnalytics.vue'
import NewReportDialog from '../components/NewReportDialog/NewReportDialog.vue'
import { mapGetters } from 'vuex'

export default {
  components: { BasePageLayout, GeneratedReportAnalyticsCard, NewReportDialog },
  data: () => ({
    newReportDialogOpen: false,
  }),
  computed: {
    ...mapGetters(['hubAnalyticsLimits']),
    hasRfvPermission() {
      return this.$getAllowedModules()['rfv'] && this.$permissions.havePagePermission('clientes/rfv')
    },
    hasDrePermission() {
      return this.$getAllowedModules()['offer_management'] && this.$permissions.havePagePermission('empresa/faturamento_incremental')
    },
    allLimitsReached() {
      const rfvLimits = this.hubAnalyticsLimits?.rfv
      const dreLimits = this.hubAnalyticsLimits?.dre
      if (rfvLimits && dreLimits) {
        let createdTotalSum = 0
        let limitTotalSum = 0
        const rfvCreatedTotalSum = rfvLimits.notRecurrent.createdTotal + rfvLimits.recurrent.createdTotal
        const dreCreatedTotalSum = dreLimits.notRecurrent.createdTotal + dreLimits.recurrent.createdTotal
        const rfvLimitTotalSum = rfvLimits.notRecurrent.limitTotal + rfvLimits.recurrent.limitTotal
        const dreLimitTotalSum = dreLimits.notRecurrent.limitTotal + dreLimits.recurrent.limitTotal
        if (this.hasDrePermission) {
          createdTotalSum += dreCreatedTotalSum
          limitTotalSum += dreLimitTotalSum
        }
        if (this.hasRfvPermission) {
          createdTotalSum += rfvCreatedTotalSum
          limitTotalSum += rfvLimitTotalSum
        }
        return createdTotalSum === limitTotalSum
      } else return false
    },
  },
  methods: {
    refetchData() {
      this.$refs.generatedReportAnalytics?.fetchData()
    },
  },
}
</script>

<style lang="scss" scoped></style>
